import { Errors } from '@/helpers/Errors';
export default {
	namespaced: true,
	state: {
		bread_active: null,
		bread_list: null,
		errors: new Errors(),
		toDoList: [],
		teamListData: [],
		resourceId: 0,
		type: 0,
	},
	getters: {},
	mutations: {
		SET_DATA(state, data) {
			eval("state." + data.name + " = data.data;");
		}
	},
	actions: {
		listData(state, payload) {
			axios.get('/api/v2/todo/' + payload.resourceId + '/' + payload.type)
				.then(response => {
					state.commit('SET_DATA', { name: 'toDoList', data: response.data.data });
					state.commit('SET_DATA', { name: 'resourceId', data: payload.resourceId });
					state.commit('SET_DATA', { name: 'type', data: payload.type });
					state.dispatch('teamList');
				})
				.catch(error => {
					state.state.errors.record(error.response.data.errors);
				});
		},

		save(state, payload) {
			axios.post('/api/v2/todo/save', {
				description: payload.description,
				done: payload.done,
				resourceId: payload.resourceId,
				type: payload.type,
				teamId: payload.teamId,
				date: payload.date,
				user_id: payload.user_id
			})
				.then(function () {
					state.dispatch('listData', payload);
				})
				.catch(error => {
					state.state.errors.record(error.response.data.errors);
				});
		},

		deleteToDo(state, payload) {
			axios.post('/api/v2/todo/delete', {
				id: payload.id,
				resourceId: state.state.resourceId,
				type: state.state.type
			})
				.then(function () {
					state.dispatch('listData', { resourceId: state.state.resourceId, type: state.state.type });
				})
				.catch(error => {
					state.state.errors.record(error.response.data.errors);
				});
		},

		isItCompleted: function (state, payload) {
			axios.post('/api/v2/todo/completed', {
				id: payload.id,
				resourceId: payload.resourceId,
				type: payload.type
			})
				.then(function () {
					state.dispatch('listData', payload);
				})
				.catch(error => {
					state.state.errors.record(error.response.data.errors);
				});
		},
	}
}
